import * as React from 'react';
import { Link } from 'react-router-dom';
import { contractAddress, dAppName } from 'config';
import { routeNames } from 'routes';
import {
  DappUI,
  refreshAccount,
  transactionServices,
  useGetAccountInfo,
  useGetLoginInfo,
  useGetNetworkConfig
} from '@elrondnetwork/dapp-core';
import Actions from './Actions';
import ContractDatas from './ContractDatas';
import { getContractData, getContractDataBoolean } from 'apiRequests';
import { StateType } from './types';
let initInterval = false;
const Home = () => {
  const { success, fail, hasActiveTransactions } =
    transactionServices.useGetActiveTransactionsStatus();
  const [state, setState] = React.useState<StateType>({
    price: '',
    inWhitelist: '1',
    inMint: '0'
  });

  const {
    ExtensionLoginButton,
    WebWalletLoginButton,
    LedgerLoginButton,
    WalletConnectLoginButton
  } = DappUI;
  const { isLoggedIn } = useGetLoginInfo();
  const account = useGetAccountInfo();
  const {
    network: { apiAddress }
  } = useGetNetworkConfig();
  const fetchData = () => {
    if (success || fail || !hasActiveTransactions) {
      let contractFunction = 'getNftPrice';
      getContractData({
        apiAddress,
        address: account.address,
        contractAddress,
        contractFunction
      }).then(({ data, success: transactionsFetched }) => {
        setState((prevState) => ({
          price: data.toString(),
          inWhitelist: prevState.inWhitelist,
          inMint: prevState.inMint
        }));
      });
      contractFunction = 'isAllowlistEnabled';
      getContractData({
        apiAddress,
        address: account.address,
        contractAddress,
        contractFunction
      }).then(({ data, success: transactionsFetched }) => {
        setState((prevState) => ({
          price: prevState.price,
          inWhitelist: data,
          inMint: prevState.inMint
        }));
      });
      contractFunction = 'isPaused';
      getContractData({
        apiAddress,
        address: account.address,
        contractAddress,
        contractFunction
      }).then(({ data, success: transactionsFetched }) => {
        setState((prevState) => ({
          price: prevState.price,
          inWhitelist: prevState.inWhitelist,
          inMint: data === '0' ? '0' : '1'
        }));
      });
      refreshAccount();
    }
  };
  const { price, inWhitelist, inMint } = state;
  React.useEffect(fetchData, [success, fail, hasActiveTransactions]);
  React.useEffect(() => {
    if (initInterval === false) {
      initInterval = true;
      setInterval(() => {
        fetchData();
      }, 30000);
    }
  }, [initInterval]);
  /*React.useEffect(() => {
    if (isLoggedIn) {
      window.location.href = routeNames.dashboard;
    }
  }, [isLoggedIn]);*/

  /*

   */
  return (
    <div className='container'>
      <div className='row'>
        <div className='col-12 col-md-6'>
          <img
            className='mint-gif rounded-lg'
            src='https://static.wixstatic.com/media/c6c23f_2e5e28abd0a54480b470e7c10fe1db1c~mv2.gif'
          />
        </div>
        <div className='col-12 col-md-6 mint-data'>
          <ContractDatas
            price={state.price}
            inWhitelist={inWhitelist}
            inMint={inMint}
          />
          {isLoggedIn ? (
            <div>
              {inMint === '1' ? <Actions price={price} /> : <div></div>}
            </div>
          ) : (
            <div className='text-center bg-white mt-5 py-4 rounded-lg'>
              <p className='text-black h5 mb-4'>Connect your wallet</p>
              <ExtensionLoginButton
                callbackRoute={routeNames.home}
                loginButtonText={'Extension'}
              />
              <WebWalletLoginButton
                callbackRoute={routeNames.home}
                loginButtonText={'Web wallet'}
              />
              <LedgerLoginButton
                loginButtonText={'Ledger'}
                callbackRoute={routeNames.home}
                className={'test-class_name'}
              />
              <WalletConnectLoginButton
                callbackRoute={routeNames.home}
                loginButtonText={'Maiar'}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
